import { render, staticRenderFns } from "./ColorPickerPopover.vue?vue&type=template&id=bc86bf36&scoped=true"
import script from "./ColorPickerPopover.vue?vue&type=script&lang=js"
export * from "./ColorPickerPopover.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerPopover.vue?vue&type=style&index=0&id=bc86bf36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc86bf36",
  null
  
)

export default component.exports